import axios from 'axios';

export const HTTP = axios.create({
    baseURL: window.process.env.API_HOST,
    headers: {
        Authorization: 'Bearer '+window.process.env.API_TOCKEN
    }
});



// WEBPACK FOOTER //
// ./src/core/http/http-common.js